import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaSave, FaSpinner, FaTags } from 'react-icons/fa';
import { getCategory, createCategory, updateCategory } from './supplierService';
import DashboardLayout from '../../layouts/DashboardLayout';
import Input from '../../components/shared/Input';
import {
  FormContainer,
  FormSection,
  FormHeader,
  BackButton,
  FormGrid,
  FormField,
  SubmitButton
} from '../../components/styled/FormComponents';

const SupplierCategoryForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    description: '' // Optional: if you want to add a description field
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategory = async () => {
      if (!id) return;
      
      try {
        setLoading(true);
        const data = await getCategory(id);
        setFormData({
          name: data.name,
          description: data.description || ''
        });
      } catch (err) {
        setError('Failed to load category');
        console.error('Error fetching category:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategory();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (id) {
        await updateCategory(id, formData);
      } else {
        await createCategory(formData);
      }
      navigate('/suppliers/categories');
    } catch (err) {
      setError('Failed to save category');
      console.error('Error saving category:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <FormContainer>
        <FormHeader>
          <BackButton onClick={() => navigate('/suppliers/categories')}>
            <FaArrowLeft /> Back to Categories
          </BackButton>
          <h2>{id ? 'Edit Category' : 'New Category'}</h2>
        </FormHeader>

        <form onSubmit={handleSubmit}>
          <FormSection>
            <h3>Category Information</h3>
            <FormGrid>
              <FormField index={0}>
                <Input 
                  label="Category Name"
                  icon={<FaTags />}
                  value={formData.name}
                  onChange={(e) => setFormData({
                    ...formData,
                    name: e.target.value
                  })}
                  placeholder="Enter category name"
                  required
                  disabled={loading}
                />
              </FormField>
            </FormGrid>

            {error && (
              <FormField index={2}>
                <div className="error-message">{error}</div>
              </FormField>
            )}
          </FormSection>

          <SubmitButton type="submit" disabled={loading}>
            {loading ? (
              <>
                <FaSpinner className="icon-spin" />
                {id ? 'Updating...' : 'Creating...'}
              </>
            ) : (
              <>
                <FaSave />
                {id ? 'Update Category' : 'Create Category'}
              </>
            )}
          </SubmitButton>
        </form>
      </FormContainer>
    </DashboardLayout>
  );
};

export default SupplierCategoryForm;